<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-button-toolbar
          key-nav
          aria-label="Toolbar with button groups"
          class="demo-inline-spacing"
        >
          <!-- group 2 -->
          <b-button-group>
            <router-link :to="{name: 'instruktori-unos-casa', params: {}}">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
              >
                {{ $t('NoviCas') }}
              </b-button>
            </router-link>
          </b-button-group>
        </b-button-toolbar>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body :title="$t('CasoviPrakticneObuke')">
        <div>
          <b-table
            v-if="Object.entries(items).length"
            :items="items"
            :fields="fields"
            striped
            responsive
            class="mb-0"
            :tbody-tr-class="rowClass"
          >
            <template #cell(detalji)="row">
              <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
              <b-form-checkbox
                v-model="row.detailsShowing"
                @change="row.toggleDetails"
              />
            </template>
            <template #cell(id)="data">
              <b-button-group
                size="sm"
              >
                <router-link
                  v-if="data.item.status !== 'zakljucen' || (data.item.izmena === 'ZahtevanaOdobrena')"
                  :to="{
                    name: 'instruktori-casovi-prakticne-obuke-izmena',
                    params: { id: data.item.id }
                  }"
                >
                  <b-button
                    variant="info"
                    size="sm"
                  >
                    {{ $t("Izmeni") }}
                  </b-button>
                </router-link>
                <b-button
                  v-if="data.item.status === 'zakljucen' && !data.item.zahtevana_promena"
                  v-b-modal.modal-zahtevaj-izmenu
                  variant="primary"
                  size="sm"
                  @click="casZaIzmenu(data.item.id)"
                >
                  {{ $t("ZahtevajIzmenu") }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-xl
                  variant="outline-primary"
                  size="sm"
                  @click="casId = data.item.id"
                >
                  {{ $t('Mapa') }}
                </b-button>
              </b-button-group>
            </template>
            <template #cell(nocnaVoznja)="data">
              <b-badge
                :variant="data.item.nocnaVoznja === 1 ? 'dark' : 'warning'"
              >
                {{ data.item.nocnaVoznja === 1 ? $t('Nocna') : $t('Dnevna') }}
              </b-badge>
            </template>
            <template #cell(kod_casa)="data">
              {{ data.item.kod_casa }}{{ data.item.opterecenje ? '-O' : '' }}
            </template>
            <template #cell(izmena)="data">
              <b-badge
                v-if="data.item.status === 'zakljucen'"
                :variant="data.item.izmena === 'ZahtevanaOdobrena' ? 'success' : (data.item.izmena === 'NijeZahtevana' ? 'secondary' : 'danger')"
              >
                {{ data.item.izmena === 'ZahtevanaOdobrena' ? $t('ZahtevanaOdobrena') : (data.item.izmena === 'NijeZahtevana' ? $t('NijeZahtevana') : $t('Zahtevana')) }}
              </b-badge>
            </template>

            <!-- full detail on click -->
            <template #row-details="row">
              <b-card>
                <b-table-simple
                  small
                  responsive
                >
                  <b-tbody>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('Status') }}
                      </b-th>
                      <b-td>{{ $t(row.item.status) }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('VremePocetka') }}
                      </b-th>
                      <b-td>{{ row.item.vreme_pocetka }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('VremeZavrsetka') }}
                      </b-th>
                      <b-td>{{ row.item.vreme_zavrsetka }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('Dvocas') }}
                      </b-th>
                      <b-td>{{ row.item.dvocas ? $t('Dvocas') : $t('NijeDvocas') }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('PocetnoStanjeNaPutometru') }}
                      </b-th>
                      <b-td>{{ row.item.pocetno_stanje_na_putometru }}km</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th
                        class="col-3"
                      >
                        {{ $t('KrajnjeStanjeNaPutometru') }}
                      </b-th>
                      <b-td>{{ row.item.krajnje_stanje_na_putometru }}km</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-card>
            </template>

            <template #cell(status)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
          </b-table>
          <b-alert
            v-else
            variant="primary"
            show
          >
            <div
              class="alert-body"
              style="padding: 30px;"
            >
              <span>{{ $t('NisuUnetiCasoviPrakticneObuke') }}</span>
            </div>
          </b-alert>
        </div>
      </b-card-body>
      <b-modal
        id="modal-xl"
        ok-only
        :ok-title="$t('Zatvori')"
        centered
        size="xl"
        :title="$t('ProlazneTacke')"
      >
        <b-card-text>
          <Mape
            :cas-id="casId"
          />
        </b-card-text>
      </b-modal>
    </b-card>
    <b-modal
      id="modal-zahtevaj-izmenu"
      ok-only
      ok-variant="danger"
      :ok-title="$t('Posalji')"
      modal-class="modal-danger"
      centered
      :title="$t('ZahtevajIzmenuZaCas')"
      @ok="potvrdiZahtevanjeIzmene"
    >
      <b-card-text>
        {{ $t('DaLiSteSigurniDaZeliteDaIzmeniteOvajCas?') }}
      </b-card-text>
      <b-form-textarea
        id="napomena_za_izmenu"
        v-model="napomena_za_izmenu"
        :placeholder="$t('Napomena')"
        rows="3"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BTableSimple,
  BTbody,
  BTr,
  BTh,
  BTd,
  BFormCheckbox,
  BButton,
  BButtonToolbar,
  BCardBody,
  BBadge,
  BButtonGroup,
  BCard,
  BCardText,
  BFormTextarea,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Mape from '../../autoskola-admin/mape/Index.vue'

export default {
  components: {
    BTable,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BButton,
    BFormCheckbox,
    BCardBody,
    BBadge,
    BButtonGroup,
    BCard,
    BButtonToolbar,
    BCardText,
    BFormTextarea,
    Mape,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        'detalji',
        { key: 'datum', label: this.$i18n.t('Datum') },
        { key: 'ime_kandidata', label: this.$i18n.t('Kandidat') },
        { key: 'vozilo_podaci', label: this.$i18n.t('Vozilo') },
        { key: 'kod_casa', label: this.$i18n.t('KodCasa') },
        { key: 'nocnaVoznja', label: this.$i18n.t('NocnaVoznja') },
        { key: 'izmena', label: this.$i18n.t('Izmena') },
        { key: 'id', label: this.$i18n.t('Akcije') },
      ],
      /* eslint-disable global-require */
      items: [],
      idCasaZaIzmenu: '',
      napomena_za_izmenu: '',
      casId: 5,
    }
  },
  mounted() {
    this.pokupiListu()
  },
  methods: {
    pokupiListu() {
      this.$http.get('/instruktori/casovi-prakticne-obuke').then(response => {
        this.items = response.data.casovi
      })
    },
    casZaIzmenu(id) {
      this.idCasaZaIzmenu = id
    },
    potvrdiZahtevanjeIzmene() {
      const data = { zahtevana_promena: true, napomena_za_izmenu: this.napomena_za_izmenu }
      this.$http.put(`/instruktori/casovi-prakticne-obuke/${this.idCasaZaIzmenu}`, data).then(() => {
        this.pokupiListu()
      })
    },
    rowClass(item, type) {
      const colorClass = 'bg-warning bg-lighten-4'
      if (!item || type !== 'row') { return }

      // eslint-disable-next-line consistent-return
      if (item.status === 'zakljucen') { return colorClass }
    },
  },
}
</script>
